module.exports = __webpack_public_path__ + "fonts/8ddb9bae731ca965661a4ba275ec94de.txt";